import './styles.scss'

export function Checkbox({ isChecked, onChange }) {
  const handleKeyDown = (event) => {
    if (event.key === ' ' || event.keyCode === 32) {
      event.preventDefault();
      onChange();
    }
  };

  return (
    <label className='custom-checkbox' tabIndex={0} onKeyDown={handleKeyDown}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
      />
      <span className="checkmark" />
    </label>
  )
}